export default function () {
    addReportEvent();
}

/*Report Functions*/
const addReportEvent = () => {
    let $addReportBtn = $('#AddReport');

    if ($addReportBtn.length) {
        $addReportBtn.click(function () {
            $('.js-report-form').removeClass('hide-v');
            $('.js-add-report').addClass('hide-v');
            //Attach Report Events
            toggleGridSprocEntry();
            addNewParamEvent();
            
            //Attach Initial Param events
            AttachParamEvents();
        });
    }
};
const toggleGridSprocEntry = () => {
    let $gridRender = $('#GridRender'),
        $gridSproc = $('#GridStoredProcedure');
    if ($gridRender.length && $gridSproc.length) {
        $gridRender.on('change', function () {
            if ($gridRender.prop('checked')) {
                $gridSproc.parent().parent().removeClass('hide-v');
            } else {
                $gridSproc.parent().parent().addClass('hide-v');
                $gridSproc.val('');
            }
        })
    }
}
const addNewParamEvent = () => {
    let $addParamBtn = $('#AddParam');

    if ($addParamBtn.length) {
        $addParamBtn.click(function (event) {
            event.preventDefault();

            $.post('/Account/UserAdmin/AddParam', {count: $('.js-param-form').length}, function (response) {
                $('.js-param-forms').append(response);
                AttachParamEvents();
            });
        });
    }
}

/*Param Functions*/
const AttachParamEvents = () => {
    attachParamTypeEvent();
    toggleLookupGridInfo();
    //Attach List Events
    addNewListItemEvent();
}
const attachParamTypeEvent = () => {
    let $paramTypes = $('[id$=Type]');
    if ($paramTypes.length) {
        $paramTypes.unbind('change');
        $paramTypes.on('change', function () {
            let k_paramType = $(this).data('kendoDropDownList'),
                paramIndex = this.id.split('_')[1],
                $thisParent = $(this).parents('.js-param-form'),
                $listItems = $thisParent.find('.js-list-form');
            if (k_paramType && k_paramType.value() === 'list') {
                $(`[id*=AddList_${paramIndex}]`).parent().show();
            } else {
                $(`[id*=AddList_${paramIndex}]`).parent().hide();
                $listItems.html('');
            }
        })
    }
}
const toggleLookupGridInfo = () => {
    let $lookupGrid = $('[id$=_Grid]');

    if ($lookupGrid.length) {
        $lookupGrid.unbind('change');
        $lookupGrid.on('change', function () {
            let $self = $(this)
            if ($self.prop('checked')) {
                $self.parent().parent().find('.js-grid-info').show();
            } else {
                $self.parent().parent().find('.js-grid-info').hide();
            }
        })
    }
}

/*List Functions*/
const addNewListItemEvent = () => {
    let $addLIstItemBtn = $('[id*=AddList]');

    if ($addLIstItemBtn.length) {
        $addLIstItemBtn.unbind('click');
        $addLIstItemBtn.click(function (event) {
            event.preventDefault();

            let paramIndex = this.id.split('_')[1];
            let $parent = $(this).parents('.js-param-form');
            let $formsContainer = $parent.find('.js-list-forms');
            let listCounts = $parent.find('.js-list-form').length;
            let indexCounts = `${paramIndex},${listCounts}`;

            $.post('/Account/UserAdmin/AddListItem', {indexCounts: indexCounts}, function (response) {
                $formsContainer.append(response);
            });
        });
    }
};